import { ENDPOINTS_MANAGER_FOR_EMPLOYEE } from 'common/endpoints/manager-for-employee.endpoints';

export default class ManagerForEmployeeService {

  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  getManagerForEmployee(employeeId) {
    return this.http.get(ENDPOINTS_MANAGER_FOR_EMPLOYEE.get.managerForEmployee(employeeId)).then(response => {
      return response.data;
    });
  }

}


// WEBPACK FOOTER //
// ./client/app/common/services/managerForEmployee.service.js